export default [
  {
    path: '/test',
    name: 'test',
    meta: {
      title: ''
    },
    component: () => import('@/views/test.vue')
  }
]
